import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as storage from 'reporting-data/lib/storage';
import { PREVIOUS_PATH_STORAGE_KEY } from '../constants/navigation';
import { findParentSubAppKey } from 'sales-analytics-lib/utils/report-hybrid-srv-sub-app-data';
export const useTemplateNavigation = () => {
  const history = useHistory();
  const navigateToTemplate = useCallback(subAppKey => {
    var _history$location, _history$location2;
    const currentPath = `${(_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.pathname}${(_history$location2 = history.location) === null || _history$location2 === void 0 ? void 0 : _history$location2.search}`;
    storage.set(PREVIOUS_PATH_STORAGE_KEY, currentPath);
    const parentSubAppKey = findParentSubAppKey(subAppKey);
    if (parentSubAppKey && parentSubAppKey !== subAppKey) {
      const params = new URLSearchParams();
      params.set('tab', subAppKey);
      history.push(`/templates/${parentSubAppKey}?${params.toString()}`);
    } else {
      // Single-tab hybrid subapps or non-hybrid subapps
      history.push(`/templates/${subAppKey}`);
    }
  }, [history]);
  return {
    navigateToTemplate
  };
};